module.exports = __webpack_public_path__ + "img/docs-info-1.a8e3618a.jpg";